import { useCallback } from 'react';

import { useLazyQuery } from '@apollo/client';
import type { Payments_PaymentProcessorId as PaymentProcessorId } from '__generated__/graphql-types';

import GetSubscriptionPaymentMethodUpdateUrl from 'bundles/payments-common/api/GetSubscriptionPaymentMethodUpdateUrl.graphql';
import type {
  GetSubscriptionPaymentMethodUpdateUrlQuery,
  GetSubscriptionPaymentMethodUpdateUrlQueryVariables,
} from 'bundles/payments-common/api/__generated__/GetSubscriptionPaymentMethodUpdateUrl';

export const useSubscriptionPaymentMethodUpdateUrl = () => {
  const [getSubscriptionPaymentMethodUpdateUrl] = useLazyQuery<
    GetSubscriptionPaymentMethodUpdateUrlQuery,
    GetSubscriptionPaymentMethodUpdateUrlQueryVariables
  >(GetSubscriptionPaymentMethodUpdateUrl, { context: { clientName: 'gatewayGql' } });

  return useCallback<(paymentProcessorId: PaymentProcessorId) => Promise<void>>(
    async (paymentProcessorId) => {
      const { data } = await getSubscriptionPaymentMethodUpdateUrl({ variables: { paymentProcessorId } });
      const customerPortalUrl = data?.PaymentProcessors?.getSubscriptionPaymentMethodUpdateUrl.customerPortalUrl;
      if (customerPortalUrl) window.location.assign(customerPortalUrl);
    },
    [getSubscriptionPaymentMethodUpdateUrl]
  );
};

export default useSubscriptionPaymentMethodUpdateUrl;
